<template>
  <div class="wrap">
    <h1 class="common-header">{{ $t('372') }}</h1>
    <!-- 水印设置 -->
    <div class="by-content">
      <h1 class="title">{{ $t('1581') }}</h1>
      <!-- 说明 -->
      <p class="notes">{{ $t('1132') }}</p>
      <el-radio-group :disabled="!$p('menu.settings.security.edit')" v-model="data.watermark" @change="doSubmit">
        <el-radio label="0">{{ $t('1280') }}</el-radio>
        <el-radio label="1">{{ $t('1281') }}</el-radio>
      </el-radio-group>
    </div>
    <!-- 自动停职离职设置 -->
    <div class="by-content">
      <h1 class="title">{{ $t('1816') }}</h1>
      <!-- 说明 -->
      <p class="notes">{{ $t('1817') }}</p>
      <el-radio-group v-model="data.is_open" @change="handlerChange" :disabled="!isEdit">
        <el-radio :label="1">{{ $t('1818') }}</el-radio>
        <el-radio :label="0">{{ $t('1819') }}</el-radio>
      </el-radio-group>
      <div class="security-detail">
        <el-form :model="data" :rules="rules" ref="form">
          <p v-if="data.is_open">
            <span>{{ $t('auto_quit') }}</span>
            <el-form-item v-if="isEdit" prop="suspension_day" class="inline">
              <el-input class="short-input" v-model="data.suspension_day" v-number="{ max: 30, min: 1 }" />
            </el-form-item>
            <span v-else>{{ data.suspension_day }}</span>
            <span>{{ $t('auto_quit_1') }}{{ $t('auto_quit_2') }}</span>
            <el-form-item v-if="isEdit" prop="resign_day" class="inline">
              <el-input class="short-input" v-model="data.resign_day" v-number="{ max: 30, min: 1 }" />
            </el-form-item>
            <span v-else>{{ data.resign_day }}</span>
            <span>{{ $t('auto_quit_3') }} {{ $t('auto_quit_4') }}</span>
            <el-form-item v-if="isEdit" prop="resign_date" class="inline">
              <el-select v-model="data.resign_date" :placeholder="$t('221')" class="short-select" v-if="isEdit">
                <el-option v-for="(item, index) in options" :key="item" :label="item" :value="index"> </el-option>
              </el-select>
            </el-form-item>
            <span v-else>{{ data.resign_date > 0 ? $t('1856', { x: data.resign_date }) : $t('1855') }}</span>
          </p>
        </el-form>
      </div>
      <br />
      <div class="page-wrap">
        <template v-if="isEdit">
          <el-button @click="handlerCancel" size="small">{{ $t('66') }}</el-button>
          <el-button type="primary" :loading="saveLoading" @click="setAutoSuspensionResign" size="small">{{
            $t('67')
          }}</el-button>
        </template>
        <!-- 编辑 -->
        <el-button
          v-if="$p('menu.settings.security.edit') && !isEdit"
          type="primary"
          @click="isEdit = true"
          size="small"
          >{{ $t('71') }}</el-button
        >
      </div>
    </div>
    <!-- 停职登录设置 -->
    <div class="by-content">
      <h1 class="title">{{ $t('1582') }}</h1>
      <!-- 说明 -->
      <p class="notes">{{ $t('1583') }}</p>
      <el-radio-group :disabled="!$p('menu.settings.security.edit')" v-model="data.suspension_login" @change="doSubmit">
        <el-radio label="1">{{ $t('1584') }}</el-radio>
        <el-radio label="0">{{ $t('1585') }}</el-radio>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
import '@/views/payroll/salary-scheme/detail/directive.js'
// 接口地址api
import { getSecuritySetting, setSecuritySetting, setAutoSuspensionResign, getAutoSuspensionResign } from 'api/settings'

export default {
  data() {
    //  $t('1856', { x: data.resign_date }) : $t('1855') }}
    return {
      options: Array.from({ length: 31 }, (item, index) => {
        if (index === 0) return this.$t('1855')
        return this.$t('1856', { x: index })
      }),
      saveLoading: false,
      isEdit: false,
      rules: {
        suspension_day: [{ required: true, message: this.$t('1593') }],
        resign_day: [{ required: true, message: this.$t('1593') }],
        resign_date: [{ required: true, message: this.$t('1593') }]
      },
      data: {
        suspension_login: '',
        watermark: '1',
        is_open: 1, // 0 关闭 1开启
        suspension_day: 3, // 停职天数
        resign_day: 4, // 离职天数
        resign_date: 0 // 离职日期
      }
    }
  },
  async created() {
    // 获取安全设置
    const { data } = await getSecuritySetting()
    this.data = Object.assign(this.data, data)
    // 获取自动停职离职
    this.getAutoSuspensionResign()
  },
  methods: {
    // 获取自动停职接口
    getAutoSuspensionResign() {
      getAutoSuspensionResign().then(res => {
        this.data = Object.assign(this.data, res.data)
      })
    },
    // 设置自动停职接口
    setAutoSuspensionResign(_, state) {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.saveLoading = true
          setAutoSuspensionResign(this.data)
            .finally(() => {
              this.saveLoading = false
            })
            .then(() => {
              this.isEdit = Boolean(state)
            })
        }
      })
    },
    // 取消
    handlerCancel() {
      this.isEdit = false
      getAutoSuspensionResign().then(res => {
        this.data = Object.assign(this.data, res.data)
      })
    },
    handlerChange() {
      this.isEdit = true
    },
    doSubmit() {
      setSecuritySetting(this.data).then(res => {
        window.location.reload()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.inline {
  margin: 10px;
}
.notes {
  margin-bottom: 20px;
  line-height: 20px;
}
.security-detail {
  display: flex;
  margin-top: 10px;
  align-items: top;
  line-height: 20px;
}
.short-select {
  width: 140px;
}
</style>
